export function normalizeDate(input) {
    if (!input) return null

    let [datePart = '', timePart = '00:00:00'] = input.trim().split(' ')

    // Normalize date (YYYY-MM-DD)
    let [year = '1970', month = '01', day = '01'] = datePart.split('-')
    year = year.padStart(4, '0')
    month = month.padStart(2, '0')
    day = day.padStart(2, '0')
    const normalizedDate = `${year}-${month}-${day}`

    // Normalize time (HH:mm:ss)
    let [h = '00', m = '00', s = '00'] = timePart.split(':')
    h = h.padStart(2, '0')
    m = m.padStart(2, '0')
    s = s.padStart(2, '0')
    const normalizedTime = `${h}:${m}:${s}`

    return `${normalizedDate} ${normalizedTime}`
}
